/**
 * Visual marker for rule rows / details where `created_by === 'beacon_seed'`.
 * Bootstrap rules ship with the migration `033_rule_library.ts` and don't go
 * through the candidate review queue, so they look identical to reviewed
 * rules unless we explicitly distinguish them. The badge is informational
 * (slate, not warning) — it doesn't imply the rule is bad, just that its
 * provenance was hand-curated rather than community-extracted.
 */
import { Icon } from './ui/Icon.js';

interface SeedBadgeProps {
  /** The rule's `created_by` field. Renders `null` when not 'beacon_seed'. */
  createdBy?: string | null;
  /** Override default size. */
  size?: 'sm' | 'md';
  className?: string;
}

export function SeedBadge({ createdBy, size = 'sm', className = '' }: SeedBadgeProps) {
  if (createdBy !== 'beacon_seed') return null;
  const sizeClass = size === 'md' ? 'text-xs' : 'text-xs';
  return (
    <span
      data-testid="seed-badge"
      className={`hub-chip capitalize ${sizeClass} ${className}`}
      title="Bootstrap rule from the seed migration. Not reviewed via the community-rule-ingestion queue."
    >
      <Icon name="bx-leaf" />
      Seed
    </span>
  );
}
